import styled from "styled-components";
import { isMobile } from "react-device-detect";
import { screenHeight } from "~/config/dimensions";

export const Space = styled.div`
  height: ${screenHeight(isMobile ? 7 : 20)}px;
`;
